import { render, staticRenderFns } from "./tabGroup.vue?vue&type=template&id=375be6ae&scoped=true"
import script from "./tabGroup.vue?vue&type=script&lang=js"
export * from "./tabGroup.vue?vue&type=script&lang=js"
import style0 from "./tabGroup.vue?vue&type=style&index=0&id=375be6ae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "375be6ae",
  null
  
)

export default component.exports